import { useQuery } from '@tanstack/react-query';
import { posRestaurant } from '../../../api/posAPI';
import usePosStore from '../../../stores/posStore';

export function useWaiters() {
  const { posToken } = usePosStore();

  const query = useQuery({
    queryKey: ['pos', 'waiters', posToken],
    queryFn: async () => {
      const res = await posRestaurant.waiters(posToken);
      return res.data.waiters || [];
    },
    enabled: !!posToken,
    staleTime: 60_000,
  });

  return {
    waiters: query.data || [],
    isLoading: query.isLoading,
    error: query.error?.response?.data?.message || query.error?.message || null,
    refetch: query.refetch,
  };
}
